module.exports = __webpack_public_path__ + "img/6.39dff7df.jpg";